import script from "./OutsideBuildingView.vue?vue&type=script&setup=true&lang=js"
export * from "./OutsideBuildingView.vue?vue&type=script&setup=true&lang=js"

import "./OutsideBuildingView.vue?vue&type=style&index=0&id=4cee5f0a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cee5f0a"]])

export default __exports__